import * as React from "react";
const SvgVectorWhiteIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M12 13 8 9l-1 1 5 5 5-5-1-1z", clipRule: "evenodd" }));
export default SvgVectorWhiteIcon;
